<template>
  <div>
    <Main
      ref="main"
      :loading="loading"
      @reload="getData"
      @saveQty="saveQty"
      :packingType="packingType"
      :tableData="tableGoodsData"
      :disabled="disabled"
    >
      <Header slot="header" @showDialog="visible = true" :disabled="disabled" />
    </Main>

    <!-- <ChooseOrderGoodsDialog
      :title="title"
      :type="type"
      ref="goodsDiaolog"
      :visible="visible"
      :changeOrderCode="changeOrderCode"
      @close="visible = false"
      @reload="getData"
      @confirm="addData"
    /> -->
  </div>
</template>
<script>
import Main from './main'
import Header from './header.vue'
// import ChooseOrderGoodsDialog from '../choose-order-goods/dialog.vue'

export default {
  props: {
    orderInspectionCode: { type: String, default: '' },
    changeOrderCode: { type: String, default: '' },
    orderBatchGoodsList: { type: Array, default: () => [] },
    packingType: { type: String, default: 'A' },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Main,
    Header,
    // ChooseOrderGoodsDialog
  },
  data() {
    return {
      type: 'checkbox',
      title:
        this.$l('INDEX.dialog_label_not_input') || '未录入批次产品剩余数量',
      tableGoodsData: [],
      loading: false,
      visible: false,
    }
  },
  mounted() {
    this.getData(this.orderInspectionCode)
  },
  watch: {
    orderBatchGoodsList: {
      handler() {
        this.tableGoodsData = this.orderBatchGoodsList
      },
      immediate: true,
    },
  },
  methods: {
    showDialog() {
      this.visible = true
    },
    //获取验收产品明细信息
    getData(code) {
      if (!code) return
      this.loading = true
      this.tableGoodsData = []
      this.$api
        .orderInspectionGoodsListApi({
          orderInspectionCode: code,
        })
        .then((res) => {
          this.loading = false
          this.tableGoodsData = res.body.data
        })
    },
    delTable() {
      this.tableGoodsData = []
    },
    addData(res) {
      if (!res) return
      var concatList = this.tableGoodsData.concat(res)
      this.tableGoodsData = this.handleDuplicateRemoval(concatList)
    },

    handleDuplicateRemoval(list) {
      let userList = []
      let hash = {}
      userList = list.reduce((preVal, curVal) => {
        hash[curVal.orderGoodsCode]
          ? ''
          : (hash[curVal.orderGoodsCode] = true && preVal.push(curVal))
        return preVal
      }, [])
      return userList
    },
    getTableData() {
      return this.$refs.main.getTableData()
    },
    updateTable(val) {
      this.$refs.main.updateTable(val)
    },
    saveQty(param) {
      this.$emit('saveQty', param)
    },
    updateTotBoxQty(val) {
      this.$refs.main.updateTotBoxQty(val)
    },
  },
}
</script>
